const SECONDS_IN_HOUR = 60 * 60;
const HOURS_IN_DAY = 24;

export const isExpirationDateClose = (expirationDate: Date, days: number): boolean => {
  const currentDate = new Date();
  const expirationDateInDays = expirationDate.getTime() / (SECONDS_IN_HOUR * HOURS_IN_DAY * 1000);
  const currentDateInDays = currentDate.getTime() / (SECONDS_IN_HOUR * HOURS_IN_DAY * 1000);
  const differenceInDays = expirationDateInDays - currentDateInDays;

  return differenceInDays <= days;
};
